import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
export const Chip = ({ className, children }) => {
    return (_jsx("div", { className: cn('px-stack-roomy py-stack-tight rounded-pill text-body-sm w-fit text-nowrap', 'bg-surface border-border border text-neutral-fg', className), children: children }));
};
